import React, { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import RestoreIcon from '@mui/icons-material/Restore';
import { FormControl, InputLabel, FilledInput, Grid, Select, MenuItem, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import useStyles from './styles';

function FirebaseFilters({
  conditions,
  setConditions,
  firebaseData,
  fieldsSelectionList,
  getInitialLoadData,
  setLimitValue,
  limitValue
}) {
  const classes = useStyles();
  const [operatorsSelectionList] = useState(['==']);

  const updateCondition = (index, key, value) => {
    setConditions((prev) => {
      const updated = [...prev];
      updated[index] = [...updated[index]];
      updated[index][key] = value;
      return updated;
    });
  };

  const addCondition = () => {
    setConditions((prev) => [...prev, ['', '', '']]);
  };

  const removeCondition = (index) => {
    setConditions((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <Grid container spacing={2} className={classes.containerGrid}>
    <Grid item xs={12}>
      <Grid container justifyContent="center">
        <Grid item xs={9}>
          <Grid container spacing={2}>
            {conditions.map((condition, index) => (
              <React.Fragment key={index}>
                <Grid item xs={4}>
                  <FormControl
                    fullWidth
                    variant="filled"
                    className={classes.inputField}
                    sx={{ bgcolor: 'transparent' }}
                    disabled={firebaseData.loading}
                  >
                    <InputLabel>Field</InputLabel>
                    <Select
                      value={condition[0]}
                      onChange={(e) => updateCondition(index, 0, e.target.value)}
                    >
                      {fieldsSelectionList
                        .filter((field) => {
                          const selectedFields = conditions.map((cond) => cond[0]);
                          return !selectedFields.includes(field) || condition[0] === field;
                        })
                        .map((field) => (
                          <MenuItem key={field} value={field}>
                            {field}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={4}>
                  <FormControl
                    fullWidth
                    variant="filled"
                    className={classes.inputField}
                    sx={{ bgcolor: 'transparent' }}
                    disabled={firebaseData.loading}
                  >
                    <InputLabel>Operator</InputLabel>
                    <Select
                      value={condition[1]}
                      onChange={(e) => updateCondition(index, 1, e.target.value)}
                    >
                      {operatorsSelectionList.map((op) => (
                        <MenuItem key={op} value={op}>
                          {op}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={4} display={'flex'} sx={{ position: 'relative' }}>
                  <FormControl
                    fullWidth
                    variant="filled"
                    className={classes.inputField}
                    sx={{ bgcolor: 'transparent' }}
                  >
                    <InputLabel>Value</InputLabel>
                    <FilledInput
                      disabled={firebaseData.loading}
                      value={condition[2]}
                      onChange={(e) => updateCondition(index, 2, e.target.value)}
                    />
                  </FormControl>
                  {conditions.length > 1
                    ? (<IconButton
                      disabled={firebaseData.loading}
                      onClick={() => {
                        removeCondition(index);
                      }}
                      className={classes.actionButtons}
                    >
                      < DeleteIcon />
                    </IconButton>)
                    : (
                      <>
                        <IconButton
                          disabled={firebaseData.loading}
                          onClick={() => {
                            setConditions([
                              ['', '', '']
                            ]);
                            getInitialLoadData();
                          }}
                          className={classes.actionButtons}
                        >
                          < RestoreIcon />
                        </IconButton>
                      </>
                      )}
                </Grid>
              </React.Fragment>
            ))}

            <Grid item xs={12}>
              {conditions.length < fieldsSelectionList.length && (
                <IconButton
                disableRipple
                disabled={firebaseData.loading}
                className={classes.addCondition}
                onClick={addCondition}
                >
                  + Add Condition
                </IconButton>
              )}
            </Grid>

            <Grid item xs={4}>
              <FormControl
                fullWidth
                variant="filled"
                className={classes.inputField}
                sx={{ bgcolor: 'transparent' }}
              >
                <InputLabel>Limit</InputLabel>
                <FilledInput
                  value={limitValue}
                  onChange={(e) => setLimitValue(Number(e.target.value))}
                />
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Grid>
  );
}

FirebaseFilters.propTypes = {
  conditions: PropTypes.array,
  setConditions: PropTypes.func,
  firebaseData: PropTypes.object,
  fieldsSelectionList: PropTypes.array,
  getInitialLoadData: PropTypes.func,
  setLimitValue: PropTypes.func,
  limitValue: PropTypes.any
};

export default FirebaseFilters;
